(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-start-primary.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-start-primary.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useMemo = _React.useMemo;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const distributionArrayAtom = svs.lyckoplatsen.components.shared_result.jotai.atoms.distributionArrayAtom;
const formatCurrency = svs.utils.format.Currency;
const ResultDrawStart = svs.lyckoplatsen.components.shared_result.react.components.ResultDrawStart;
const generateConicGradient = function (colors) {
  let step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
  return "conic-gradient(\n  ".concat(colors.map((color, index) => {
    const start = "calc(".concat(step, "deg * ").concat(index, ")");
    const end = "calc(".concat(step, "deg * ").concat(index + 1, ")");
    return "".concat(color, " ").concat(start, " ").concat(end);
  }).join(', '), "\n)");
};
const ResultDrawStartPrimary = () => {
  const distributionArrayRaw = useAtomValue(distributionArrayAtom);
  const distributionArray = useMemo(() => distributionArrayRaw !== null && distributionArrayRaw !== void 0 ? distributionArrayRaw : [], [distributionArrayRaw]);
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    gradient = _useState2[0],
    setGradient = _useState2[1];
  useEffect(() => {
    if (distributionArray.length > 0) {
      var _distributionArray$;
      const COLORS = distributionArray.map(_ref => {
        let color = _ref.color;
        return color;
      }).slice(1).concat(((_distributionArray$ = distributionArray[0]) === null || _distributionArray$ === void 0 ? void 0 : _distributionArray$.color) || '#FFFFFF');
      setGradient(generateConicGradient(COLORS));
    }
  }, [distributionArray]);
  return React.createElement("div", {
    className: "lp-draw-start-primary map-gradient gsap-start-primary"
  }, React.createElement("div", {
    className: "top"
  }, React.createElement(ResultDrawStart, null)), React.createElement("div", {
    className: "bottom"
  }, React.createElement("div", {
    className: "draw-wheel-wrapper gsap-draw-wheel-wrapper"
  }, React.createElement("svg", {
    className: "draw-wheel-pin gsap-draw-wheel-pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: "44",
    height: "63",
    viewBox: "0 0 44 63",
    fill: "none"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.213135 21.0765C0.213135 9.05746 9.56997 -0.00012207 21.9017 -0.00012207V0.00314734C34.1489 0.00314734 43.5902 9.06074 43.5902 21.0798C43.5902 26.0809 41.6623 29.9534 39.16 34.0729C36.6577 38.1924 21.9017 62.9999 21.9017 62.9999C21.9017 62.9999 6.94769 37.772 4.57584 34.0173C2.20399 30.2627 0.213135 26.0547 0.213135 21.0765ZM8.68405 18.0202C8.68405 14.4597 11.661 11.5996 15.2928 11.5996C18.9247 11.5996 21.9016 15.4812 21.9016 15.4812C21.9016 15.4812 24.8785 11.5996 28.5104 11.5996C32.172 11.5996 35.1192 14.4889 35.1192 18.0202C35.1192 20.8803 33.9582 27.6803 22.5565 34.5678C22.3481 34.6846 21.8719 34.9764 21.8719 34.9764C21.8719 34.9764 21.3955 34.6846 21.1872 34.5678C9.84505 27.6803 8.68405 20.8803 8.68405 18.0202Z",
    fill: "#16FFAB"
  })), React.createElement("div", {
    className: "draw-wheel gsap-draw-wheel",
    style: {
      background: gradient
    }
  }, distributionArray.map((_ref2, index) => {
    let value = _ref2.value;
    return React.createElement("div", {
      key: index,
      className: "slice",
      style: {
        '--i': index
      }
    }, React.createElement("span", null, formatCurrency(value), " kr"));
  })))));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ResultDrawStartPrimary
});

 })(window);